(function () {
  'use strict';

  angular
    .module('cosmicRadiationReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('cosmicRadiationReport', {
        url: '/cosmic-radiation-report',
        views : {
        	'cosmicRadiationReportView' : {
        		templateUrl: 'cosmic-radiation-report/views/cosmic-radiation-report.tpl.html',
                controller: 'CosmicRadiationReportCtrl',
                controllerAs: 'cosmicRadiationReport'
        	}
        }
      });
  }
}());
